module.exports = __webpack_public_path__ + "claude.svg?3a4ff8285d36fda2fb09695fd762c5b8";